module.exports = require("typescript-json-schema");